import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-myhistory',
  templateUrl: './help-myhistory.component.html'
})
export class HelpMyhistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
